import axios from "./Interceptors";
import { TCF_URL } from "./URLs";

const fileHeaders = {"Content-Type": "multipart/form-data"}

const changePassword = async (payload) => {
    return await axios.post(TCF_URL.CHANGE_PASSWORD, payload);
}

const updateUserDetails = async (payload) => {
    return await axios.post(TCF_URL.UPDATE_USER_DETAILS, payload)
}

const updateProfileImage = async (payload) => {
    return await axios.post(TCF_URL.UPDATE_PROFILE_IMAGE, payload, fileHeaders)
}

const stripeCancelSubscription = async (payload) => {
    return await axios.post(TCF_URL.STRIPE_CANCEL_SUBSCRIPTION, payload)
}

const paypalCancelSubscription = async (payload) => {
    return await axios.post(TCF_URL.PAYPAL_CANCEL_SUBSCRIPTION, payload)
}

export const profileAPIs = {
    changePassword,
    updateUserDetails,
    updateProfileImage,
    stripeCancelSubscription,
    paypalCancelSubscription
}
